import { createFileRoute } from '@tanstack/react-router'
import { lazy, Suspense } from 'react'

import type { Background } from '../lib/journeys.js'

// Onboarding loads in its own chunk with its messages (spec 025), like the journey page.
const StartPage = lazy(() => import('../components/start/StartPage.js'))

export interface StartSearch {
  /** With `background`: a recheck of this track's skills from the journey page. */
  track?: string
  background?: Background
}

const BACKGROUNDS: readonly string[] = ['new', 'some', 'professional']

export const Route = createFileRoute('/start')({
  validateSearch: (search: Record<string, unknown>): StartSearch => ({
    ...(typeof search.track === 'string' ? { track: search.track } : {}),
    ...(typeof search.background === 'string' && BACKGROUNDS.includes(search.background)
      ? { background: search.background as Background }
      : {}),
  }),
  component: StartRoute,
})

function StartRoute() {
  const { track, background } = Route.useSearch()
  return (
    <Suspense fallback={null}>
      <StartPage
        {...(track !== undefined && background !== undefined
          ? { recheck: { track, background } }
          : {})}
      />
    </Suspense>
  )
}
